/**
 * @generated SignedSource<<6554b3ba00b0ef060ebefa4e3a739597>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedIconicDesignHeadingsWrapper_itemSearch$data = {
  readonly meta: {
    readonly subHeader: string | null;
  } | null;
  readonly " $fragmentType": "SharedIconicDesignHeadingsWrapper_itemSearch";
};
export type SharedIconicDesignHeadingsWrapper_itemSearch$key = {
  readonly " $data"?: SharedIconicDesignHeadingsWrapper_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedIconicDesignHeadingsWrapper_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedIconicDesignHeadingsWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "1fcbff7b328d4b1f7e4e7887c1424d08";

export default node;
